<div class="filter-arrow-up" [style.left.px]="arrowOffset"></div>
<div class="column-filter-dialog">
 
 

  <!-- Sort Section -->
  <div class="section" *ngIf="showSort">
    <div class="sort-buttons">
      <a class="sort-btn" [class.active]="sortDirection === 'A'" (click)="sortAscending()">
        <mat-icon inline>arrow_upward</mat-icon> Sort Ascending
      </a>
      <a class="sort-btn" [class.active]="sortDirection === 'D'" (click)="sortDescending()">
        <mat-icon inline>arrow_downward</mat-icon> Sort Descending
      </a>
    </div>
  </div>

  <mat-divider *ngIf="showSort"></mat-divider>

  <!-- Filter Section -->
  <div class="section">
    <!-- Text filter -->
    <div *ngIf="dataType === 'text'" class="filter-body">
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [(value)]="textFilterMode" panelClass="column-filter-select-panel">
          <mat-option value="equals">Equals</mat-option>
          <mat-option value="search">Search</mat-option>
          <mat-option value="regex">Contains</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{textFilterMode === 'regex' ? 'Pattern' : 'Search'}}</mat-label>
        <input matInput [formControl]="textFilter" [placeholder]="textFilterMode === 'regex' ? 'Enter regex pattern...' : 'Type to filter...'">
      </mat-form-field>
    </div>

    <!-- Select filter (checkbox list) -->
    <div *ngIf="dataType === 'select'" class="filter-body checkbox-list">
      <div class="checkbox-search">
        <mat-form-field appearance="outline" class="full-width compact-field">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput [formControl]="optionSearchFilter" placeholder="Filter">
        </mat-form-field>
      </div>
      <div class="checkbox-item select-all">
        <mat-checkbox [checked]="selectAll" (change)="selectAll = $event.checked; toggleSelectAll()">
          (Select All)
        </mat-checkbox>
      </div>
      <div class="checkbox-scroll">
        <div class="checkbox-item" *ngFor="let opt of filteredSelectOptions">
          <mat-checkbox [checked]="selectedItems.has(opt)" (change)="toggleItem(opt)">
            {{opt}}
          </mat-checkbox>
        </div>
      </div>
    </div>

    <!-- Color-select filter (RAG Status style) -->
    <div *ngIf="dataType === 'color-select'" class="filter-body checkbox-list color-select-list">
      <div class="checkbox-scroll">
        <div class="checkbox-item color-select-item select-all-item">
          <mat-checkbox [checked]="selectAll" (change)="selectAll = $event.checked; toggleSelectAll()">
            All
          </mat-checkbox>
        </div>
        <div class="checkbox-item color-select-item" *ngFor="let opt of filteredSelectOptions">
          <mat-checkbox [checked]="selectedItems.has(opt)" (change)="toggleItem(opt)">
            <span class="color-dot" [style.background-color]="getColorForOption(opt)"
              [style.border]="getColorForOption(opt).toLowerCase() === '#f5f5f5' ? '1.5px solid #999' : 'none'"></span>
            {{opt}}
          </mat-checkbox>
        </div>
      </div>
    </div>

    <!-- Number filter -->
    <div *ngIf="dataType === 'number'" class="filter-body">
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [(value)]="numberFilterMode" panelClass="column-filter-select-panel">
          <mat-option value="equals">Equals</mat-option>
          <mat-option value="gt">Greater than</mat-option>
          <mat-option value="gte">Greater than or equal</mat-option>
          <mat-option value="lt">Less than</mat-option>
          <mat-option value="lte">Less than or equal</mat-option>
          <mat-option value="between">Between</mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="numberFilterMode !== 'between'">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Value</mat-label>
          <input matInput type="number" [formControl]="numberValue" placeholder="Enter a number...">
        </mat-form-field>
      </div>
      <div *ngIf="numberFilterMode === 'between'" class="number-range-row">
        <mat-form-field appearance="outline" class="number-field">
          <mat-label>Min</mat-label>
          <input matInput type="number" [formControl]="numberMin" placeholder="Min">
        </mat-form-field>
        <span class="date-separator">&ndash;</span>
        <mat-form-field appearance="outline" class="number-field">
          <mat-label>Max</mat-label>
          <input matInput type="number" [formControl]="numberMax" placeholder="Max">
        </mat-form-field>
      </div>
    </div>

    <!-- Date filter -->
    <div *ngIf="dataType === 'date'" class="filter-body">
      <mat-radio-group [(ngModel)]="filterPreset" class="date-presets">
        <mat-radio-button value="today" (change)="onPresetChange('today')">Today</mat-radio-button>
        <mat-radio-button value="last7" (change)="onPresetChange('last7')">In Last 3 Days</mat-radio-button>
        <mat-radio-button value="custom" (change)="onPresetChange('custom')">Custom Range</mat-radio-button>
        <div class="date-range-fields" *ngIf="filterPreset === 'custom'">
          <div class="date-row">
            <mat-form-field appearance="outline" class="date-field">
              <input matInput [matDatepicker]="dpFrom" [formControl]="dateFrom" placeholder="Start Date">
              <mat-datepicker-toggle matSuffix [for]="dpFrom" [disabled]="dateFrom.disabled"></mat-datepicker-toggle>
              <mat-datepicker #dpFrom></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="date-row">
            <mat-form-field appearance="outline" class="date-field">
              <input matInput [matDatepicker]="dpTo" [formControl]="dateTo" placeholder="End Date">
              <mat-datepicker-toggle matSuffix [for]="dpTo" [disabled]="dateTo.disabled"></mat-datepicker-toggle>
              <mat-datepicker #dpTo></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </mat-radio-group>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- Actions -->
  <div class="dialog-actions">
    <button mat-stroked-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="apply()">Apply</button>
  </div>
</div>
